import React from "react";
import { Form, Formik } from "formik";
import closeIcon from "../../assets/icons/close-icon.svg";
import FilterTextField from "./filter-input-fields/filter-text-field";
import { useLocation, useNavigate } from "react-router-dom";
import queryString from "query-string";
import { FormDropDown } from "../form/dropdown";
import { FilterFromToDateField } from "./filter-input-fields/filter-from-to-field";
import { FormToggleSwitch } from "../form/checkbox";

const AdminFilterDrawer = ({
  open,
  onClose = () => {},
  filterInputs = [],
  activeTab = "",
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const parsed = queryString.parse(location.search, { arrayFormat: "bracket" });

  const nestedParsed = {};
  for (const [key, value] of Object.entries(parsed)) {
    const match = key.match(/^(\w+)\[(\w+)\]$/);
    if (match) {
      const [, mainKey, subKey] = match;
      if (!nestedParsed[mainKey]) nestedParsed[mainKey] = {};
      nestedParsed[mainKey][subKey] = value;
    } else {
      nestedParsed[key] = value;
    }
  }

  const initialValues = filterInputs?.reduce((data, column) => {
    if (column) {
      const name = column.name;
      const value = nestedParsed[name];
      data[name] = value ?? "";
    }
    return data;
  }, {});

  const handleSubmit = (values) => {
    const cleanedValues = Object.fromEntries(
      Object.entries(values).filter(([key, value]) => {
        if (value === false) return false; // Exclude false values
        if (Array.isArray(value)) return value.length > 0;
        if (typeof value === "object" && value !== null) {
          return Object.values(value).some(
            (v) => v !== undefined && v !== null && v !== "" && v !== false
          );
        }
        return (
          value !== undefined &&
          value !== null &&
          value !== "" &&
          value !== false
        );
      })
    );

    const flattened = {};
    for (const [key, value] of Object.entries(cleanedValues)) {
      if (
        typeof value === "object" &&
        !Array.isArray(value) &&
        value !== null
      ) {
        for (const [subKey, subVal] of Object.entries(value)) {
          if (
            subVal !== false &&
            subVal !== undefined &&
            subVal !== null &&
            subVal !== ""
          ) {
            flattened[`${key}[${subKey}]`] = subVal;
          }
        }
      } else {
        flattened[key] = value;
      }
    }

    const searchParams = queryString.stringify(flattened, {
      arrayFormat: "bracket",
    });

    if (activeTab) {
      navigate(`${location.pathname}?${searchParams}&activeTab=${activeTab}`);
    } else {
      navigate(`${location.pathname}?${searchParams}`);
    }

    onClose();
  };

  const clearFilter = (callback) => {
    if (activeTab) {
      navigate(`${location.pathname}?activeTab=${activeTab}`);
    } else {
      navigate(`${location.pathname}`);
    }

    onClose();
    if (callback) callback();
  };

  return (
    <div
      className={`
          fixed top-0 right-0 h-full w-full max-w-[30rem] bg-white shadow-lg z-50 p-5
          transform transition-transform duration-300 ease-in-out
          ${open ? "translate-x-0" : "translate-x-full"}
        `}
    >
      <Formik
        initialValues={initialValues}
        onSubmit={handleSubmit}
        enableReinitialize={true}
      >
        {({ values, resetForm }) => (
          <Form>
            <div className="flex items-center justify-between w-full">
              <h3 className="text-lg font-bold mb-4">Filters</h3>
              <button
                type="button"
                className="p-1 bg-gray-100 rounded-full"
                onClick={onClose}
              >
                <img src={closeIcon} alt="X" width={24} height={24} />
              </button>
            </div>

            <div className="h-screen max-h-[calc(100vh-10rem)] overflow-auto">
              {filterInputs.map((input) => {
                if (input?.type === "text") {
                  console.log(values, "values");

                  return (
                    <FilterTextField
                      name={input?.name}
                      label={input?.label}
                      placeholder={`Enter ${input?.label}`}
                    />
                  );
                }

                if (input?.type === "dropdown") {
                  return (
                    <FormDropDown
                      name={input?.name}
                      label={input?.label}
                      options={input?.options}
                      value={input?.options?.find(
                        (item) => item?.value === values?.[input?.name]
                      )}
                    />
                  );
                }

                if (input?.type === "date") {
                  return (
                    <FilterFromToDateField
                      name={input?.name}
                      label={input?.label}
                      fromValue={`${values?.[input?.name]?.from}`}
                      toValue={`${values?.[input?.name]?.to}`}
                    />
                  );
                }

                if (input?.type === "switch") {
                  return (
                    <FormToggleSwitch
                      name={input?.name}
                      label={input?.label}
                      value={values?.[input?.name]}
                    />
                  );
                }

                return (
                  <>
                    <FilterTextField
                      name={input?.name}
                      label={input?.label}
                      placeholder={`Enter ${input?.label}`}
                    />
                  </>
                );
              })}
            </div>
            <div className="flex justify-end gap-2 p-2 mt-2">
              <button
                type="submit"
                className="px-4 py-2 bg-blue-600 text-white rounded"
              >
                Apply Filters
              </button>
              <button
                onClick={() => {
                  clearFilter();
                  setTimeout(() => resetForm(), 100);
                }}
                type="button"
                className="px-4 py-2 bg-secondary text-white rounded"
              >
                Clear Filters
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default AdminFilterDrawer;
